<template>
  <div class="spark-card day-placeholder-card">
    <div class="day-placeholder-subtitle">
      {{
        mergedIntoGambitId ? 'This proposal was merged into a confirmed IRL.' : 'This proposal is no longer available.'
      }}
    </div>
    <div class="day-placeholder-subtitle">
      <GamButton
        :variant="GamButtonVariant.SLAB"
        :size="GamButtonSize.SMALL"
        :is-loading="isLoading"
        @click="onClickReload"
      >
        Reload
      </GamButton>
    </div>
  </div>
</template>

<script setup lang="ts">
import { RouterNameType } from '@/core/data/config/uiConfig.interface';
import GamButton from '@/views/components/GamButton.vue';
import { GamButtonSize, GamButtonVariant } from '@/views/composables/constants/components/gamButton.constants';
import { watch } from 'vue';
import { useRouter } from 'vue-router';

interface NotFoundProps {
  date: string;
  onClickReload: () => void;
  isLoading?: boolean;
  reloadError?: string | null;
  mergedIntoGambitId?: string | null;
}

const props = defineProps<NotFoundProps>();

const router = useRouter();

watch(
  () => props.reloadError,
  (error, prevError) => {
    if (error && error !== prevError && props.date) {
      router.push({ name: RouterNameType.SPARKS, query: { date: props.date } });
    }
  },
);
</script>
